import { appointmentRequestStatus } from '../../../../config/app.config';

const { pending, completed } = appointmentRequestStatus;

export const APPOINTMENT_REQUEST_SCOPE_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'all', label: 'All' },
];

export const APPOINTMENT_REQUEST_SORT_OPTIONS = [
  { value: 'createdAt', label: 'Date', defaultOrder: -1 },
  { value: 'parentFullName', label: 'Parent', defaultOrder: 1 },
  { value: 'petName', label: 'Pet', defaultOrder: 1 },
];

export const APPOINTMENT_REQUEST_DATE_SHORTCUTS = [
  { value: 'today', label: 'Today' },
  { value: 'last 7 days', label: '7d' },
  { value: 'last 30 days', label: '30d' },
];

export const APPOINTMENT_REQUEST_FILTER_SEARCH_THRESHOLD = 8;

export const APPOINTMENT_REQUEST_OPEN_STATUSES = [pending];
export const APPOINTMENT_REQUEST_ALL_STATUSES = [pending, completed];

export function getAppointmentRequestFilterCategories({
  appointmentTypes = [],
  doctors = [],
  appointmentTypeLabel = 'Appointment Type',
}) {
  const typeChoices = appointmentTypes.map((appointmentType) => ({
    value: appointmentType._id,
    label: appointmentType.title,
  }));

  const doctorChoices = doctors.map((doctor) => ({
    value: doctor._id,
    label: doctor.name,
  }));
  doctorChoices.push({ value: 'NA', label: 'N/A' });

  return [
    {
      key: 'typeTitle',
      label: appointmentTypeLabel,
      choices: typeChoices,
    },
    {
      key: 'doctorId',
      label: 'Doctor',
      choices: doctorChoices,
    },
    {
      key: 'requestStatus',
      label: 'Request Status',
      choices: [
        { value: pending, label: 'Pending' },
        { value: completed, label: 'Completed' },
      ],
    },
  ];
}
